// extracted by mini-css-extract-plugin
export default {"header":"Header_header__p9reN","main-image":"Header_main-image__Ffuyh"};